module.exports = __webpack_public_path__ + "static/media/36.eb4453bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/36.jpg
// module id = 569
// module chunks = 0